<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-05-21 16:02:42
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-07-04 11:58:07
 * @FilePath: \qctsw-vue\packages\app\src\components\Basic\areaSelect\item.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script setup lang='ts'>
import { NSelect } from 'naive-ui'
import type { NestProvince } from '@qctsw/common'

const props = withDefaults(defineProps<{
  id?: string | undefined
  option?: NestProvince | null
  options?: NestProvince[]
  placeholder?: string
}>(), {
  option: null,
  placeholder: '请选择',
})
const emits = defineEmits({
  'update:option': (_data: NestProvince | null) => true,
  'update:id': (_data: string | undefined) => true,
})
const selectValue = ref<string | undefined>(undefined)
const selectOption = ref<NestProvince | null>(null)
function updateValueHandle(value: string | undefined, option: NestProvince | null) {
  selectValue.value = value
  selectOption.value = option
}
function findOption(value: string) {
  if (!props.options)
    return null
  for (const item of props.options) {
    if (item.id === value)
      return item
  }
  return null
}

const stops = [
  watch(() => [props.id, props.option], () => {
    if (props.id !== unref(selectValue) || !props.id)
      selectValue.value = props.id

    if (JSON.stringify(props.option) !== JSON.stringify(unref(selectOption)))
      selectOption.value = props.option
  }, { immediate: true, deep: true }),
  watch(selectValue, () => {
    const currentOption = unref(selectValue) ? findOption(unref(selectValue) as string) : null
    updateValueHandle(selectValue.value, currentOption)

    emits('update:option', unref(selectOption))
    if (props.id !== unref(selectValue))
      emits('update:id', unref(selectValue))
  }, { immediate: true }),
]

onBeforeUnmount(() => {
  stops.forEach(stop => stop())
})
</script>

<template>
  <NSelect
    :value="selectValue"
    :options="(props.options as any)"
    value-field="id"
    label-field="short_name"
    children-field="null"
    :placeholder="props.placeholder"
    clearable
    filterable
    @update:value="updateValueHandle"
  />
</template>
